export const SET_SELECTED_PRODUCT = 'RETURN_INVOICES/SET_SELECTED_PRODUCT';
export const RESET_SELECTED_PRODUCT = 'RETURN_INVOICES/RESET_SELECTED_PRODUCT';
